import { useState } from 'react';
import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { GradientOverlay, StyledBreakString, TBody, THead } from './SharedComponents';
import { CommerceFeatures, getEnrolledProductLineFeatureAccessLevels } from './CommerceFeatureTableConfig';
import CommerceFeatureTableRow from './CommerceFeatureTableRow';
import Screens from '../../constants/routing/Screens';
import UITable from 'UIComponents/table/UITable';
import { Section } from '../common/SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommerceFeatureTable = ({
  screen
}) => {
  const [expanded, setExpanded] = useState(false);
  const accessLevels = getEnrolledProductLineFeatureAccessLevels(COMMERCE);
  const handleExpandClick = () => {
    getUsageTracker().track('featureTableInteraction', {
      action: `clicked-${expanded ? 'collapse' : 'expand'}-table`,
      productLine: COMMERCE,
      screen
    });
    setExpanded(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(GradientOverlay, {
      expanded: expanded,
      children: /*#__PURE__*/_jsxs(UITable, {
        bordered: false,
        hover: false,
        className: "m-top-8",
        children: [/*#__PURE__*/_jsx(THead, {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx("h2", {
                children: screen === Screens.COMMERCE ? /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.productCatalog.tableHeader.features"
                }) : /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "commerceFeatureTable.title"
                })
              })
            }), accessLevels.map(level => {
              return /*#__PURE__*/_jsx("th", {
                scope: "col",
                children: /*#__PURE__*/_jsx(StyledBreakString, {
                  hyphenate: false,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `commerceFeatureTable.headers.${level}`
                  })
                })
              }, level);
            })]
          })
        }), /*#__PURE__*/_jsx(TBody, {
          children: CommerceFeatures.map(feature => {
            return /*#__PURE__*/_jsx(CommerceFeatureTableRow, {
              accessLevels: accessLevels,
              feature: feature
            }, feature.shortName);
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "text-center justify-center align-center",
      children: /*#__PURE__*/_jsxs(UIButton, {
        use: "transparent",
        onClick: handleExpandClick,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: expanded ? 'featureTable.collapse' : 'featureTable.expand'
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: expanded ? 'up' : 'down',
          size: "xxs",
          color: EERIE
        })]
      })
    })]
  });
};
export default CommerceFeatureTable;